import styles from '@/styles/project.module.scss';
import Layout from '@/layouts/page-base.layout';
import type { GetServerSidePropsContext } from 'next';
import type {
  TCompanyDetails,
  TBasic,
  TDetails,
  TFooter,
} from '@/types/project';
import Card from '@/components/position/card';
import { useState, useEffect } from 'react';
import { openApp, getLocalesEnv, formatMoney } from '@/utils';
import { Ellipsis } from 'antd-mobile';
import track from '@/utils/track';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { WEB3_EVENT_ID, WEB3_EVENT_OPERATE } from '@/consts';
import Cookies from 'js-cookie';
import channel from '@/utils/channel';

import compLogImg from '@/static/images/landing/company-log.jpg';
import successFilled from '@/static/images/landing/success-filled.svg';
import facebook from '@/static/images/landing/facebook.svg';
import twitter from '@/static/images/landing/twitter.svg';
import footerTextImage from '@/static/images/landing/footer-text.svg';
import ServerAPI from '@/api/server-api';
import clientAPI from '@/api/client-api';
import useOpenInstall from '@/hooks/useOpenInstall';
import useChannel from '@/hooks/useChannel';
import Head from '@/components/headv2';
import dynamic from 'next/dynamic';
import clientUrlHelper from '@/utils/client-url';
import { ShareConfig } from '@/types/head';
const WeChat = dynamic(import('@/components/wx'), { ssr: false })

function OrganizationInfo({ organizationDetail }: any) {
  const { organizationName,
    verifyStatus,
    financingStageStr,
    organizationSizeStr,
    industryStr,
    organizationLogoUrl } = organizationDetail

  return (
    <div className={styles['basic']}>
      <div className={styles['basic-left-part']}>
        <div className={styles['inline-wrap']}>
          <div className={styles['block-wrap']}>
            <div className={`${styles['company-name']} overflow-ellipsis-4`}>
              {verifyStatus === 1 ? (
                <div
                  className={`${styles['success-filled']}`}
                  style={{ backgroundImage: `url(${successFilled.src})` }}
                ></div>
              ) : (
                ''
              )}
              {organizationName}
            </div>
          </div>
        </div>

        <div className={styles['company-info']}>
          {financingStageStr ? <span>{financingStageStr}</span> : ''}
          {organizationSizeStr ? <span> · {organizationSizeStr}</span> : ''}
          {industryStr ? <span> · {industryStr}</span> : ''}
        </div>
      </div>

      <div
        className={`${styles['company-logo']} bg-img`}
        style={{
          backgroundImage: `url(${organizationLogoUrl || compLogImg.src})`,
        }}
      ></div>
    </div>
  );
}

function OrganizationDesc({ text }: any) {
  if (!text) return null;
  const { t } = useTranslation('common');
  const expandText: string = t('VIEWALL');
  const [showMore, setShowMore] = useState(true);
  const handleClickMore = () => {
    setShowMore(false);
  };

  return (
    <div className={styles['details']}>
      <h3 className={styles['h3']}>{t('Details')}</h3>

      <div className={styles['details-text']}>
        <Ellipsis
          rows={5}
          content={text}
          direction="end"
          expandText={expandText}
        />
      </div>
    </div>
  );
}

function Other() {
  return (
    <div className={styles['other']}>
      <ul className={styles['other-list']}>
        <li className={styles['other-item']}>
          <div className={styles['item-key']}>Token</div>
          <div className={styles['item-value']}>2017</div>
        </li>
        <li className={styles['other-item']}>
          <div className={styles['item-key']}>Founded Date</div>
          <div className={styles['item-value']}>2017</div>
        </li>
        <li className={styles['other-item']}>
          <div className={styles['item-key']}>Location</div>
          <div className={styles['item-value']}>2017</div>
        </li>
      </ul>
    </div>
  );
}

function Team() {
  return (
    <div className={styles['team']}>
      <h3 className={styles['h3']}>Team</h3>
      <div className={styles['team-list']}>
        <div className={`${styles['team-item']} w-1/2`}>
          <div
            className={`${styles['aratar']}`}
            style={{ backgroundImage: `url(${facebook})` }}
          ></div>
          <div className={styles['user-info']}>
            <div className={styles['user-name']}>
              Devin Finzerfdsfdsaffdsafdsa
            </div>
            <div className={styles['user-title']}>
              CEO fdsfdsafds afdsafdsafdsa
            </div>
          </div>
        </div>
        <div className={`${styles['team-item']} w-1/2`}>
          <div
            className={`${styles['aratar']}`}
            style={{ backgroundImage: `url(${facebook})` }}
          ></div>
          <div className={styles['user-info']}>
            <div className={styles['user-name']}>Devin Finzer</div>
            <div className={styles['user-title']}>CEO</div>
          </div>
        </div>
        <div className={`${styles['team-item']} w-1/2`}>
          <div
            className={`${styles['aratar']}`}
            style={{ backgroundImage: `url(${facebook})` }}
          ></div>
          <div className={styles['user-info']}>
            <div className={styles['user-name']}>Devin Finzer</div>
            <div className={styles['user-title']}>CEO</div>
          </div>
        </div>
        <div className={`${styles['team-item']} w-1/2`}>
          <div
            className={`${styles['aratar']}`}
            style={{ backgroundImage: `url(${facebook})` }}
          ></div>
          <div className={styles['user-info']}>
            <div className={styles['user-name']}>Devin Finzer</div>
            <div className={styles['user-title']}>CEO</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fundraising() {
  return (
    <div className={styles['fundraising']}>
      <h3 className={styles['h3']}>Fundraising</h3>
      <div className={styles['fundraising-text']}>
        Rounds: 5, Total raised: $ 427.1M
      </div>
    </div>
  );
}

function PositionList({ list }: { list: any[] }) {
  const { t } = useTranslation('common');

  return (
    <div className={styles['job']}>
      <h2 className={styles['job-title']}>
        {t('JOBS')}
        <div className={styles['job-count']}>{list.length}</div>
      </h2>

      <ul className={styles['job-list']}>
        {list.map((item, index) => (
          <Card {...item} key={item.id} />
        ))}
      </ul>
    </div>
  );
}

function Footer({ onClick }: any) {
  const { t } = useTranslation('common');

  return (
    <footer className={`${styles.footer} fixed bottom-0 w-full footer`}>
      <div className={`flex`}>
        <div className={`${styles['footer-text']}`} style={{ backgroundImage: `url(${footerTextImage.src})` }}>
          {t('GoToTheAPPAnd')}
          <span>{t('ViewGoodWeb3CompaniesAndPositions')}</span>
        </div>

        <button className={styles.btn} onClick={onClick}>{t('OPENAPP')}</button>
      </div>
    </footer>
  );
}
// 钩子函数，在请求时被自动调用
export async function getServerSideProps(props: GetServerSidePropsContext) {
  const start = new Date().getTime()
  const { req, res, params, query } = props

  const Language = getLocalesEnv(req, query)
  const API = new ServerAPI({ acceptLanguage: Language })

  if (!params?.id) return { notFound: true }
  const id = params.id as string
  const [company, position] = await Promise.all([
    API.landing.getOrganization(id),
    API.landing.getOrganizationPosition(id, { current: 1, size: 30 }),
  ]);

  if (!company.data) return { notFound: true };

  const organizationDetail = company.data;
  const organizationPositions = position.data.positions;
  const i18n = await serverSideTranslations(Language, ['common']);

  const end = new Date().getTime();
  res.setHeader('X-TIME-SPAN', end - start);

  return {
    props: {
      query,
      params,
      organizationPositions,
      organizationDetail,
      ...i18n,
    },
  };
}

export default function Page(props: any) {
  const { organizationDetail, organizationPositions, params, query } = props;
  const channel = useChannel()
  const openinstall = useOpenInstall()
  const appUrl = organizationDetail.share.h5.default.universeUrl
  const clientUrl = clientUrlHelper.organizationDetailUrl(params.id)
  const share = organizationDetail.share.h5
  const positionTitle = organizationPositions.map((item: any) => item.positionTitle);

  const seo = {
    title: `[SmartDeer] ${organizationDetail.organizationName} is hiring for: ${positionTitle.join(' | ')}`,
    description: `Chat directly with Global Web3 Jobs.`,
    keywords: ''
  }

  const wechatShareConfig:ShareConfig = {
    title: `[SmartDeer] ${organizationDetail.organizationName} is hiring for: ${positionTitle.join(' | ')}`,
    description: `一键直聊全球Web3工作机会。`,
    image: organizationDetail.organizationLogoUrl,
    thumbnail: organizationDetail.organizationLogoUrl,
    url: share.default.shareUrl
  }

  useEffect(() => {
    handleActivityTask(query)
  }, [])

  function handleActivityTask(query: any) {
    // 在APP页面，openId都是从url中获取的
    if (!Cookies.get('WEB3_EVENT_PROJECT')) {
      Cookies.set('WEB3_EVENT_PROJECT', WEB3_EVENT_ID)

      clientAPI.events.setOrganizationPopular(WEB3_EVENT_ID, {
        score: WEB3_EVENT_OPERATE.project.score,
        organizationUuid8: organizationDetail.uuid8,
        operateType: WEB3_EVENT_OPERATE.project.type,
        openId: '',
      })
    }
  }

  const handleClickToApp = () => {
    track.click('footer_open_app_click', {channelCode: channel?.channel, shareCode: channel?.shareCode})
    openinstall?.wakeupOrInstall({channelCode: channel?.channel, data: { path: clientUrl, shareCode: channel?.shareCode } })
    openApp(appUrl)
  }

  return (
    <Layout pagename='share_project'>
      {/* head meta */}
      <Head seo={seo} share={share}></Head>

      {/* wechat share */}
      <WeChat share={wechatShareConfig} />

      <div className={styles['company-module']}>
        <OrganizationInfo organizationDetail={organizationDetail} />
        <OrganizationDesc text={organizationDetail.shortDescription} />
        {/* <Other />
          <Team />
          <Fundraising /> */}
      </div>
      <PositionList list={organizationPositions} />
      <Footer onClick={handleClickToApp} />
    </Layout>
  );
}
